import * as Y from "yjs";
import { z } from "zod";
import { DTODocumentationHierarchyV2 } from "../../api";
import { FrontendVersionRoomYDoc } from "../version-room/frontend";

// We store pages and groups in the same way they are stored in the database.
// This means that instead of groups having childrenIds array, all items have
// parentPersistentId property that points to the parent item in the tree.
// Upon read this gets converted to the format that client expects, which is
// ordered childrenIds array on all groups.
//
// The decision behind it is that we potentially want to get rid of childrenIds
// array entirely because it makes group updates more complicated. For now
// resolving it on fly is a tradeoff for not rewriting client to stop relying
// on children ids array.

//
// Types
//

export const DocumentationHierarchySettings = z.object({
  routingVersion: z.string(),
  isDraftFeatureAdopted: z.boolean(),
  isApprovalFeatureEnabled: z.boolean(),
  approvalRequiredForPublishing: z.boolean(),
});

export type DocumentationHierarchySettings = z.infer<typeof DocumentationHierarchySettings>;

/**
 * @deprecated - Use FrontendVersionRoomYDoc.getDocumentationHierarchy
 */
export function yjsToDocumentationHierarchy(doc: Y.Doc): DTODocumentationHierarchyV2 {
  return new FrontendVersionRoomYDoc(doc).getDocumentationHierarchy();
}
